export const tool = state => state.tool;
export const toolConfig = state => state.toolConfig;
export const autoflow = state => state.autoflow;
export const autoflows = state => state.autoflows;
